import {useLayoutEffect} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';

import {RootState} from '../../../../../index';
import {getGameXpHighlightsState} from '../../../../../selectors/fortnite-game/gameXpHighlightsSelector';
import {GameXpHighlightsState} from '../../../../../reducers/fortnite-game/gameXpHighlights.reducer';
import gameXpHighlightsActions from '../../../../../actions/fortnite-game/gameXpHighlights.actions';

interface UseGameXpHighlightsState extends GameXpHighlightsState {
    reload: () => void;
}

const useGameXpHighlightsData = (islandCode?: string): UseGameXpHighlightsState => {
    const dispatch = useDispatch();

    const {data, loading, error} = useSelector<RootState, GameXpHighlightsState>(
        getGameXpHighlightsState,
        shallowEqual
    );

    const fetchData = () => {
        dispatch(gameXpHighlightsActions.getGameXpHighlights({islandCode}));
    };

    useLayoutEffect(() => {
        if (islandCode) {
            fetchData();
        }
    }, [islandCode]);

    return {
        data,
        loading,
        error,
        reload: fetchData
    };
};

export default useGameXpHighlightsData;
